import { isEmpty } from '@util/utils';

// ── 會員須知完成度與換頁卡控 ────────────────────────────────
// 來源：Asana「會員須知未打勾及簽名，無法打開至後面三頁填寫個人資訊」。

// 判斷「會員須知」這一步是否已填寫完成。
// 完成的定義是三項皆備：個資告知已勾選、總同意已勾選、會員簽名已簽。
//
// contractSurvey：會員須知頁面的資料。
//（items = 各須知卡片的勾選狀態、isConfirm = 總同意、signImg = 簽名圖）
// privacyItemIndex：個資告知位於 items 的索引；null 代表沒有個資卡片，此時只檢查總同意與簽名。
// isNoticeReady：須知清單是否已確定；false 時一律判定為未完成。
// 註：使用暫存功能時簽名不會被保存，因此暫存後重開，教練需請會員重新簽名。
export const isMembershipSurveyCompleted = ({
    contractSurvey,
    privacyItemIndex = null,
    isNoticeReady = true,
}) => {
    // 換頁卡控是隨個資告知一起加的，不追溯舊版，維持原本可自由換頁的行為。
	if (privacyItemIndex === null) return true;
	if (!isNoticeReady) return false;

    const { items = [], isConfirm, signImg } = contractSurvey || {};
    const isPrivacyChecked = privacyItemIndex === null || Boolean(items[privacyItemIndex]);

    return isPrivacyChecked && Boolean(isConfirm) && !isEmpty(signImg);
};

// 點擊步驟時，即時判斷目標步驟是否可以進入。
// guardedFromIndex：從第幾步開始需要 isCompleted 才放行。
// 入會與移入申請書的步數及會員須知位置不同，因此由呼叫端傳入，不在規則內寫死。
// isReadOnly 一律放行，避免已完成的舊文件無法檢視後續步驟。
export const canAccessMembershipStep = ({
    nextIndex,
    guardedFromIndex,
    isReadOnly,
    isCompleted,
}) =>
    isReadOnly ||
    isCompleted ||
    nextIndex < guardedFromIndex;
